import classnames from 'classnames';
import React, { ReactNode } from 'react';

import styles from './styles.module.scss';

export type Props = {
  className?: string;
  children: ReactNode;
};

const BaseItem = ({ className, children }: Props) => {
  return (
    <div className={classnames(styles.suggestionItem, className)}>
      {children}
    </div>
  );
};

export default BaseItem;
